import React from 'react';
import { FaCopy } from 'react-icons/fa';
import NewTooltip from './NewTooltip';

interface CopyButtonProps {
  data: any;
  label?: string;
  className?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ data, label = 'Copiar JSON', className }) => {
  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      const text = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
      try {
        await navigator.clipboard.writeText(text ?? '');
      } catch (err) {
        console.error('Clipboard copy failed', err);
      }
    }
  };

  return (
    <NewTooltip content={label} alignment="left">
      <button type="button" onClick={handleCopy} className={`p-2 hover:bg-gray-200 rounded ${className || ''}`}>
        <FaCopy />
      </button>
    </NewTooltip>
  );
};

export default CopyButton;
